import React, {Fragment} from "react";

import {sum} from "@pg-mono/nodash";

import {IRegionListMap} from "../../../region/types/IRegionListMap";

interface IProps {
    region: IRegionListMap;
}

export const MapGeneratedDescriptionFloors = (props: IProps) => {
    const {
        region: {name_declension_what, stats}
    } = props;

    const hasRegionAnyProperties = !!sum([
        stats?.properties_flats_ground_floor || 0,
        stats?.properties_flats_ground_floor_with_garden || 0,
        stats?.properties_flats_low_floor || 0,
        stats?.properties_flats_high_floor || 0,
        stats?.properties_flats_last_floor || 0,
        stats?.properties_flats_last_floor_with_terrace || 0
    ]);

    if (!hasRegionAnyProperties) {
        return null;
    }

    return (
        <Fragment>
            <p>
                Jakie nieruchomości składają się na ofertę deweloperską regionu? <br /> Na mapie {name_declension_what} możesz odnaleźć inwestycje:
            </p>
            <ul>
                <Floor count={stats?.properties_flats_ground_floor || 0} text="parterze" />
                <Floor count={stats?.properties_flats_ground_floor_with_garden || 0} text="parterze z ogródkiem" />
                <Floor count={stats?.properties_flats_low_floor || 0} text="niskim piętrze" />
                <Floor count={stats?.properties_flats_high_floor || 0} text="wysokim piętrze" />
                <Floor count={stats?.properties_flats_last_floor || 0} text="ostatnim piętrze" />
                <Floor count={stats?.properties_flats_last_floor_with_terrace || 0} text="ostatnim piętrze z tarasem" />
            </ul>
        </Fragment>
    );
};

const Floor = (props: {text: string; count: number}) => {
    return props.count ? <li>z mieszkaniami na {`${props.text} (${props.count})`}</li> : null;
};
import React, {Fragment} from "react";

import {sum} from "@pg-mono/nodash";

import {IRegionListMap} from "../../../region/types/IRegionListMap";

interface IProps {
    region: IRegionListMap;
}

export const MapGeneratedDescriptionFloors = (props: IProps) => {
    const {
        region: {name_declension_what, stats}
    } = props;

    const hasRegionAnyProperties = !!sum([
        stats?.properties_flats_ground_floor || 0,
        stats?.properties_flats_ground_floor_with_garden || 0,
        stats?.properties_flats_low_floor || 0,
        stats?.properties_flats_high_floor || 0,
        stats?.properties_flats_last_floor || 0,
        stats?.properties_flats_last_floor_with_terrace || 0
    ]);

    if (!hasRegionAnyProperties) {
        return null;
    }

    return (
        <Fragment>
            <p>
                Jakie nieruchomości składają się na ofertę deweloperską regionu? <br /> Na mapie {name_declension_what} możesz odnaleźć inwestycje:
            </p>
            <ul>
                <Floor count={stats?.properties_flats_ground_floor || 0} text="parterze" />
                <Floor count={stats?.properties_flats_ground_floor_with_garden || 0} text="parterze z ogródkiem" />
                <Floor count={stats?.properties_flats_low_floor || 0} text="niskim piętrze" />
                <Floor count={stats?.properties_flats_high_floor || 0} text="wysokim piętrze" />
                <Floor count={stats?.properties_flats_last_floor || 0} text="ostatnim piętrze" />
                <Floor count={stats?.properties_flats_last_floor_with_terrace || 0} text="ostatnim piętrze z tarasem" />
            </ul>
        </Fragment>
    );
};

const Floor = (props: {text: string; count: number}) => {
    return props.count ? <li>z mieszkaniami na {`${props.text} (${props.count})`}</li> : null;
};
